<template>
    <div>
        <div class="field">
            <label class="label">{{ translate("discipline_packages.mma_number_of_rounds") }}</label>
            <div class="control">
                <div class="select">
                    <select v-model="numberOfRounds">
                        <option v-for="n in [1, 2]" :key="n" :value="n">{{ n }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div v-if="showBreakBetweenRounds" class="field">
            <label class="label">{{ translate("discipline_packages.mma_break_between_rounds") }}</label>
            <div class="control">
                <div class="select">
                    <select v-model="breakBetweenRounds">
                        <option v-for="option in breakOptions" :key="option.value" :value="option.value">
                            {{ translate(option.labelTranslationKey) }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../../Common/translations";
    import { useDisciplinePackagesStore } from "../disciplinePackagesStore";
    import { ScoreboardSettings } from "../../Api/disciplinePackages";
    import {
        WRESTLING_BREAK_BETWEEN_ROUNDS_OPTIONS,
        WrestlingBreakBetweenRoundsValue,
        getWrestlingBreakForRoundsChange,
        normalizeWrestlingBreakSelection,
    } from "./wrestlingBreakBetweenRounds";

    const store = useDisciplinePackagesStore();
    const breakOptions = WRESTLING_BREAK_BETWEEN_ROUNDS_OPTIONS;

    function updateActiveScoreboardSettings(settings: ScoreboardSettings): void {
        if (store.activeTabIndex !== null) {
            store.disciplineOverrideConfigs[store.activeTabIndex].scoreboardSettings = settings;
            return;
        }

        store.disciplineDefaultConfig.scoreboardSettings = settings;
    }

    const numberOfRounds = computed({
        get: () => store.activeScoreboardSettings.numberOfRounds ?? 2,
        set: (value: number | null) => {
            const current = store.activeScoreboardSettings;

            updateActiveScoreboardSettings({
                ...current,
                numberOfRounds: value,
                breakBetweenRounds: getWrestlingBreakForRoundsChange(value, current.breakBetweenRounds),
            } satisfies ScoreboardSettings);
        },
    });

    const showBreakBetweenRounds = computed(() => numberOfRounds.value >= 2);

    const breakBetweenRounds = computed({
        get: () => normalizeWrestlingBreakSelection(store.activeScoreboardSettings.breakBetweenRounds),
        set: (value: WrestlingBreakBetweenRoundsValue) => {
            updateActiveScoreboardSettings({
                ...store.activeScoreboardSettings,
                breakBetweenRounds: value,
            });
        },
    });
</script>

<style scoped></style>
